import { render, staticRenderFns } from "./BtnInserirDotacao.vue?vue&type=template&id=706d5cd8"
import script from "./BtnInserirDotacao.vue?vue&type=script&lang=js"
export * from "./BtnInserirDotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports